<form [formGroup]="formGroup">
  <div class="{{ viewMode }}">
    <div class="grid grid-cols-2 gap-10 justify-content-start items-center">
      <div class="grid grid-cols-2 gap-10 justify-self-start w-full">
        <div class="w-full justify-self-start">
          <mat-form-field class="w-full" id="{{ id }}">
            <mat-label class="custom-label-error">{{ translationService.translate(limitTranslationKey + 'Text') }}</mat-label>
            <input
              subscriptSizing="dynamic"
              id="{{ id }}Input"
              matInput
              type="number"
              min="0"
              (keydown)="enforceNumberField({ event: $event })"
              value="{{ limit }}"
              formControlName="{{ limitFormControlName }}"
              [readonly]="!editMode"
              (input)="checkValue($event)"
              required
            />
            @if (editMode && !ntrAgeIsNull && formGroup.get(limitFormControlName).value > (id === 'ntr' ? mrtToValidate.ntr : id === 'age' ?
            mrtToValidate.age : mrtToValidate.totalCombined)) {
            <mat-hint id="ntrAgeLimitWarning" class="mic-info">{{ translationService.translate('exceedWarningText') }}</mat-hint>
            } @if (editMode && formGroup.get(limitFormControlName).hasError('required')) {
            <mat-error id="input-error">
              {{ translationService.translate('selectAtleastOneValueErrorText') }}
            </mat-error>
            }
          </mat-form-field>
        </div>
        @if (shouldDisplayActionDetails()) {
        <div class="w-full justify-self-end">
          <app-spec-dropdown
            id="actionField"
            [editMode]="isDefault ? false : editMode"
            [id]="id + 'Action'"
            [formGroup]="formGroup"
            [controlName]="'action'"
            [options]="actionValues"
            [label]="translationService.translate('actionText')"
          />
        </div>
        }
      </div>

      @if (this.translationService.translateToEnglish(getActionType(this.formGroup.get('action').value)) ===
      this.translationService.translateToEnglish(getActionType(ActionType.DOWNGRADE)) && shouldDisplayActionDetails()) {
      <div class="grid grid-cols-3 gap-10 justify-self-end w-full">
        <div class="w-full justify-self-start">
          <app-spec-dropdown
            [editMode]="editMode"
            [id]="id + 'Application'"
            [formGroup]="formGroup"
            [controlName]="'application'"
            [options]="applicationValues"
            [label]="translationService.translate('applicationText')"
          />
        </div>

        <div class="w-full">
          <app-spec-dropdown
            [editMode]="editMode"
            [id]="id + 'Axle'"
            [formGroup]="formGroup"
            [controlName]="'axle'"
            [options]="axleValues"
            [label]="translationService.translate('axleText')"
          />
        </div>

        <div class="w-full justify-self-end">
          <app-dropdown-multiple-search
            [editMode]="editMode"
            [id]="id + 'Treads'"
            [formGroup]="formGroup"
            [controlName]="'treads'"
            [options]="treadsValues"
            [label]="translationService.translate('treadsText')"
          />
        </div>
      </div>
      } @if (this.translationService.translateToEnglish(getActionType(this.formGroup.get('action').value)) !==
      this.translationService.translateToEnglish(ActionType.DOWNGRADE) && shouldDisplayActionDetails()) {
      <div class="grid grid-cols-2 gap-10 justify-self-end w-full">
        <div class="w-full justify-self-start">
          <app-spec-dropdown
            [editMode]="editMode"
            [id]="id + 'Disposition'"
            [formGroup]="formGroup"
            [controlName]="'disposition'"
            [options]="dispositionValues"
            [label]="translationService.translate('dispositionText')"
          />
        </div>
        @if (this.translationService.translateToEnglish(getActionType(this.formGroup.get('action').value)) ===
        translationService.translateToEnglish(getActionType(ActionType.REJECT)) &&
        this.translationService.translateToEnglish(getDispositionType(this.formGroup.get('disposition').value)) ===
        translationService.translateToEnglish(getDispositionType(DispositionType.SCRAP))) {
        <div class="w-full justify-self-end">
          <app-spec-dropdown
            [editMode]="editMode"
            [id]="id + 'DisposalCode'"
            [formGroup]="formGroup"
            [controlName]="'disposalCode'"
            [options]="disposalCodeValues"
            [label]="translationService.translate('disposalCodeText')"
          />
        </div>
        }
      </div>
      }
    </div>
  </div>
</form>
